import type {PropertyDefinitionBase, PropertyValue} from '@github-ui/custom-properties-types'

export const getReadOnlyValue = (definition: PropertyDefinitionBase, value?: PropertyValue) => {
  if (value) return value
  if (definition.defaultValue) return `Default (${getCommaSeparatedString(definition.defaultValue)})`
  return ''
}

const getCommaSeparatedString = (value: PropertyValue) => (Array.isArray(value) ? value.join(', ') : value)
